import React from 'react';
import 'twin.macro';
import { SubNavigationSidebar } from 'components/SubNavigationSidebar';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuItemProps } from 'components/NavLink/MenuItem';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';
import {
  Bars3BottomLeftIcon,
  BriefcaseIcon as Briefcase,
  ClipboardDocumentListIcon,
  CreditCardIcon as CreditCard,
  EnvelopeIcon as Mail,
  HomeModernIcon,
  KeyIcon as Key,
  PencilIcon as Pencil,
  TrashIcon as Trash,
  UserCircleIcon as UserCircle,
  UsersIcon as Users,
} from '@heroicons/react/24/outline';
import { CarnetIcon } from 'components/Icons/icons/CarnetIcon';
import MagicWandIcon from 'components/Icons/icons/MagicWand';

type I18nTitleKey = Extract<
  ParseKeys<'userSettings', {}, undefined>,
  `submenu.${string}`
>;

const menuItems: (Omit<MenuItemProps, 'title'> & { title: I18nTitleKey })[] = [
  {
    route: 'account',
    icon: UserCircle,
    title: 'submenu.account',
  },
  {
    route: 'bo-editor',
    icon: ClipboardDocumentListIcon,
    title: 'submenu.referentiels',
  },
  {
    route: 'materials',
    icon: Briefcase,
    title: 'submenu.materials',
  },
  {
    route: 'custom-fields',
    icon: Pencil,
    title: 'submenu.customFields',
  },
  {
    route: 'notation-systems',
    icon: CarnetIcon,
    title: 'submenu.notationSystems',
  },
  {
    route: 'bo-labels',
    icon: Bars3BottomLeftIcon,
    title: 'submenu.curriculumLabels',
  },
  {
    route: 'change-password',
    icon: Key,
    title: 'submenu.changePassword',
  },
  {
    route: 'parrainage',
    icon: Users,
    title: 'submenu.referral',
  },
  {
    route: 'subscription',
    icon: CreditCard,
    title: 'submenu.subscription',
  },
  {
    route: 'usage',
    icon: MagicWandIcon,
    title: 'submenu.aiUsage',
  },
  {
    route: 'school-subscription',
    icon: HomeModernIcon,
    title: 'submenu.schoolSubscription',
  },
  {
    route: 'contact',
    icon: Mail,
    title: 'submenu.contact',
  },
  {
    route: 'trash',
    icon: Trash,
    title: 'submenu.trash',
  },
];

interface Props {
  className?: string;
}

export function Sidebar(props: Props) {
  const { t } = useTranslation(['userSettings', 'common']);
  const navigate = useNavigate();
  const location = useLocation();
  const route = location.pathname.split('/')[3];

  return (
    <TwoColumnsCardSidebar.Side className={props.className}>
      <h1 tw="mb-4">{t('common:sidebar.settings')}</h1>
      <SubNavigationSidebar
        items={menuItems.map(i => ({
          ...i,
          title: t(i.title),
          route: `/settings/${i.route}`,
        }))}
        goTo={navigate}
        currentRoute={`/settings/${route}`}
      />
    </TwoColumnsCardSidebar.Side>
  );
}
